import { useEffect, useState } from 'react'
import { Alert, App, Button, Card, Checkbox, Space, Typography } from 'antd'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { translateError } from '@/shared/api/errors'
import { queryKeys } from '@/shared/api/queryKeys'
import { MENU_MODULES, fetchHiddenModules, saveHiddenModules, type MenuModule } from './menuApi'

/** Tashkilot ishlatmaydigan bo'limlarni menyudan yashirish; sahifalar va huquqlar o'zgarmaydi */
export function MenuModulesCard() {
  const { t } = useTranslation()
  const { message } = App.useApp()
  const queryClient = useQueryClient()
  const current = useQuery({ queryKey: queryKeys.tenantMenu, queryFn: ({ signal }) => fetchHiddenModules(signal) })
  const [hidden, setHidden] = useState<MenuModule[]>([])

  useEffect(() => {
    if (current.data) setHidden([...current.data])
  }, [current.data])

  const save = useMutation({
    mutationFn: () => saveHiddenModules(hidden),
    onSuccess: (saved) => {
      queryClient.setQueryData(queryKeys.tenantMenu, saved)
      void message.success(t('menuModules.saved'))
    },
  })

  const dirty = current.data !== undefined && [...current.data].sort().join() !== [...hidden].sort().join()

  return (
    <Card title={t('menuModules.title')}>
      <Typography.Paragraph type="secondary">{t('menuModules.description')}</Typography.Paragraph>
      {current.isError ? <Alert type="error" showIcon message={translateError(current.error, t)} /> : null}
      {save.isError ? (
        <Alert type="error" showIcon style={{ marginBottom: 12 }} message={translateError(save.error, t)} />
      ) : null}
      <Checkbox.Group<MenuModule>
        value={hidden}
        onChange={setHidden}
        disabled={current.isPending || save.isPending}
        style={{ width: '100%' }}
      >
        <Space direction="vertical">
          {MENU_MODULES.map((module) => (
            <Checkbox key={module} value={module}>
              {t(`menuModules.module.${module}`)}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
      <div style={{ marginTop: 16 }}>
        <Button type="primary" onClick={() => save.mutate()} loading={save.isPending} disabled={!dirty}>
          {t('common.save')}
        </Button>
      </div>
    </Card>
  )
}
